import React, { useState, useEffect } from "react";

import { ResultProvider } from "../../dataProvider/results";
import { getResultOrigin } from "../../dataProvider/origin";
import { TYPES, SUBTYPES } from "../../envs/core";

import Header from "../../components/header";
import AtresPieChart from "../../components/charts/atresPieChart";
import TableCompare from "../../components/table";

const Compare = ({ match }) => {
  const {
    year,
    type,
    electionNumber,
    placesIds,
    province,
    community
  } = match.params;

  const [resultOrigin, setResultOrigin] = useState({});

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, placesIds)
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});
  }, [year, type, electionNumber]);

  return (
    <div className="ComparePage">
      <Header>
        <h2>ELECCIONES GENERALES</h2>
      </Header>
      {resultOrigin && resultOrigin.primary && (
        <ResultProvider
          active={resultOrigin.primary.active}
          year={year}
          type={type}
          subtype={type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE}
          electionNumber={electionNumber}
          placeId={placesIds}
        >
          {dataResult => (
            <div>
              <div className="CompareWrapper">
                <AtresPieChart
                  data={dataResult.partiesResult || []}
                  dataKey={"votesPercent"}
                  showLabel={
                    type !== TYPES.REGIONAL
                      ? !province && !community
                      : !Boolean(province)
                  }
                  seatTotal={dataResult.totalSeats || 0}
                />
              </div>

              <TableCompare
                data={dataResult.partiesResult || []}
                details
                legend={["*UNIDAS PODEMOS: Podemos - IU - Equo - En Comú PODEM - En Común Podemos"]}
              />
            </div>
          )}
        </ResultProvider>
      )}
    </div>
  );
};

export default Compare;
